export default {
  // Navbar
  nav_home: "Inicio",
  nav_excursions: "Excursiones",
  nav_reviews: "Opiniones",
  nav_contact: "S\u00edguenos",
  nav_book_now: "Reservar",
  nav_menu: "Men\u00fa",
  nav_whatsapp: "WhatsApp",

  // Hero
  hero_badge: "Uno de los mejores lugares para reservar tu aventura en Tenerife",
  hero_title_1: "Descubre Tenerife.",
  hero_title_2: "Vive la aventura.",
  hero_subtitle: "Desde expediciones en buggy por volcanes hasta parques tem\u00e1ticos de clase mundial \u2014 reserva tours inolvidables y entradas por las Islas Canarias con expertos locales de confianza.",
  hero_cta_explore: "Explorar excursiones",
  hero_cta_talk: "Habla con un experto",
  hero_badge_local_support: "Soporte local",
  hero_badge_local_support_sub: "en 3 idiomas",
  hero_badge_secure: "Reserva segura",
  hero_badge_secure_sub: "de confianza y verificada",

  // Categories
  cat_title: "Explorar por categor\u00eda",
  cat_heading: "Todo tipo de aventura en Tenerife",
  cat_subtitle: "Desde senderismo volc\u00e1nico hasta avistamiento de ballenas \u2014 nuestras categor\u00edas te ayudan a encontrar la experiencia perfecta.",
  cat_bus: "Excursiones en autob\u00fas",
  cat_parks: "Parques tem\u00e1ticos",
  cat_tickets: "Entradas",
  cat_boat: "Paseos en barco",
  cat_adventure: "Aventura y naturaleza",
  cat_water: "Actividades acu\u00e1ticas",
  cat_food: "Gastronom\u00eda",
  cat_rental: "Alquiler de coches y motos",
  cat_activities: "actividades",

  // Excursions List
  el_badge: "Experiencias destacadas",
  el_heading: "Excursiones seleccionadas en Tenerife",
  el_subtitle: "Nuestras aventuras m\u00e1s reservadas este mes \u2014 desde paseos de adrenalina hasta parques familiares.",
  el_view_all: "Ver todas las excursiones",
  el_explore_all_btn: "Explorar Todas las Excursiones",
  el_explore_all_sub: "Todas las categor\u00edas \u2014 aventura, paseos en barco, deportes acu\u00e1ticos y m\u00e1s",
  exall_badge: "Todas las Excursiones",
  exall_heading: "Explora Todas las Excursiones en Tenerife",
  exall_subtitle: "Cada aventura, espect\u00e1culo y actividad acu\u00e1tica que ofrecemos \u2014 filtra por categor\u00eda o explora todas.",
  exall_filter_all: "Todas",
  exall_results_label: "excursiones",
  exall_no_results: "No se encontraron excursiones en esta categor\u00eda.",
  el_from: "Desde",
  el_view_details: "Ver detalles",
  el_pickup: "Recogida",
  el_accessible: "Accesible",

  // Why Us
  wu_badge: "Por qu\u00e9 reservar con nosotros",
  wu_heading: "Tu socio de confianza para excursiones en Tenerife",
  wu_subtitle: "Somos una agencia de excursiones en Tenerife con una misi\u00f3n simple: ayudarte a vivir lo mejor de la isla sin trampas tur\u00edsticas.",

  wu_local_experts: "Expertos locales de Tenerife",
  wu_local_experts_body: "Agencia con sede en El Médano — nuestros guías viven y respiran la isla.",
  wu_languages: "Soporte local en 3 idiomas",
  wu_languages_body: "Hablamos polaco, ingl\u00e9s y espa\u00f1ol. Sin barreras idiom\u00e1ticas, solo buen servicio.",
  wu_handpicked: "Experiencias seleccionadas",
  wu_handpicked_body: "Cada tour y entrada se prueba y selecciona personalmente por calidad, diversi\u00f3n y valor.",
  wu_personal: "Ayuda personalizada",
  wu_personal_body: "\u00bfNo sabes qu\u00e9 elegir? Escr\u00edbenos por WhatsApp y te haremos un plan personalizado.",

  // Testimonials (homepage)
  tm_badge: "Opiniones Reales",
  tm_heading: "Lo que dicen nuestros clientes",
  tm_subtitle: "Reseñas auténticas de viajeros que reservaron directamente con nosotros, compartidas en Facebook con sus propias palabras.",
  tm_based_on: "basado en opiniones de Facebook",
  tm_source_fb: "Recomendado en Facebook",
  tm_show_more: "Leer más",
  tm_show_less: "Mostrar menos",
  tm_see_more_fb: "Ver más opiniones en Facebook",

  // Reviews
  rev_badge: "Opiniones de clientes",
  rev_heading: "Lo que dicen nuestros viajeros",
  rev_subtitle: "Opiniones reales de personas reales que reservaron con nosotros.",
  rev_rating_label: "opiniones verificadas",
  rev_1_title: "\u00a1Pura adrenalina!",
  rev_1_body: "El mejor d\u00eda de nuestras vacaciones en Tenerife. Nuestro gu\u00eda fue divertid\u00edsimo y el paisaje volc\u00e1nico es irreal. \u00a1El Polaris RZR es una bestia \u2014 muy recomendable!",
  rev_2_title: "El mejor parque que hemos visitado",
  rev_2_body: "Es el mejor parque en el que he estado, vale la pena. Muy limpio, los animales incre\u00edbles, la comida muy buena. \u00a1Un gran d\u00eda!",
  rev_3_title: "Gran oferta combinada",
  rev_3_body: "Yani nos ayud\u00f3 a reservar \u2014 muy amable y servicial. El billete combinado fue una gran oferta y nos divertimos mucho en ambos parques.",
  rev_4_title: "Excelente servicio al cliente",
  rev_4_body: "El personal fue extremadamente servicial en todos los sentidos, un gran viaje, recomendar\u00eda reservar con ellos.",
  rev_5_title: "\u00a1Todo fue perfecto!",
  rev_5_body: "Todo funcion\u00f3 sin problemas, desde el traslado hasta la entrada. Ambos parques son de clase mundial \u2014 Siam Park especialmente nos dej\u00f3 boquiabiertos.",
  rev_6_title: "El terreno volc\u00e1nico es impresionante",
  rev_6_body: "Conducir por el paisaje lunar del Teide fue surrealista. Las tapas y la cata de vinos despu\u00e9s fueron el final perfecto.",

  // Contact CTA
  ct_badge: "Mantente conectado",
  ct_social_heading: "Sigue nuestras aventuras",
  ct_social_subtitle: "Mira fotos diarias, historias y momentos detr\u00e1s de c\u00e1maras desde Tenerife. \u00a1Etiqu\u00e9tanos en tus excursiones!",
  ct_subtitle: "Cu\u00e9ntanos qu\u00e9 buscas \u2014 un experto local de Tenerife te contactar\u00e1 en unas horas con un itinerario personalizado.",
  ct_whatsapp_label: "WhatsApp",
  ct_whatsapp_number: "+48 792 842 613",
  ct_whatsapp_hours: "07:00 \u2013 21:00 todos los d\u00edas",
  ct_form_heading: "Env\u00edanos tu solicitud",
  ct_form_subtitle: "Crearemos la experiencia perfecta en Tenerife para ti.",
  ct_form_name: "Tu nombre",
  ct_form_email: "Email",
  ct_form_interested: "Interesado en",
  ct_form_date: "Fecha preferida",
  ct_form_message: "Mensaje",
  ct_form_message_placeholder: "Cu\u00e9ntanos sobre tu grupo, fechas, hotel...",
  ct_form_send: "Enviar solicitud",
  ct_form_sending: "Enviando...",
  ct_success_title: "\u00a1Gracias, recibido!",
  ct_success_body: "Un experto local se pondr\u00e1 en contacto en unas horas.",
  ct_form_error: "Algo sali\u00f3 mal. Int\u00e9ntalo de nuevo.",
  ct_form_network_error: "Error de red. Revisa tu conexi\u00f3n e int\u00e9ntalo de nuevo.",
  ct_option_buggy: "Expedici\u00f3n Buggy al Volc\u00e1n",
  ct_option_jungle: "Entradas Jungle Park",
  ct_option_twin: "Twin Ticket (Loro + Siam)",
  ct_option_fishing: "Excursión de Pesca en el Mar",
  ct_option_custom: "Itinerario personalizado",

  // Footer
  ft_tagline: "Descubre Tenerife con tours seleccionados, entradas y aventuras inolvidables por la isla. Confianza de miles de viajeros.",
  ft_contact: "Contacto",
  ft_whatsapp: "WhatsApp",
  ft_whatsapp_number: "+48 792 842 613",
  ft_phone_local_label: "Local (Tenerife)",
  ft_hours: "07:00 \u2013 21:00 (Todos los d\u00edas)",
  ft_location: "El Médano, Tenerife, Islas Canarias",
  ft_explore: "Explorar",
  ft_all_excursions: "Todas las excursiones",
  ft_buggy: "Expedici\u00f3n Buggy al Volc\u00e1n",
  ft_jungle: "Entradas Jungle Park",
  ft_twin: "Twin Ticket Combo",
  ft_reviews: "Opiniones de clientes",
  ft_social: "S\u00edguenos",
  ft_social_text: "M\u00e1s fotos, historias y actualizaciones en nuestras redes sociales.",
  ft_copyright: "\u00a9 2026 Mateo Teneryfa. Todos los derechos reservados.",
  ft_privacy: "Pol\u00edtica de privacidad",
  ft_cookies: "Pol\u00edtica de cookies",
  ft_terms: "T\u00e9rminos y condiciones",

  // Excursion page
  ex_home: "Inicio",
  ex_excursions: "Excursiones",
  ex_what_youll_do: "Qu\u00e9 har\u00e1s",
  ex_highlights: "Puntos destacados",
  ex_included: "Incluido",
  ex_recommendations: "Recomendaciones",
  ex_requirements: "Requisitos",
  ex_schedule: "Horario de espect\u00e1culos",
  ex_hours: "Horario de apertura",
  ex_languages: "Idiomas disponibles",
  ex_reviews: "Opiniones de clientes",
  ex_related: "Tambi\u00e9n te puede gustar",
  ex_more: "M\u00e1s experiencias",
  ex_see_all: "Ver todas",
  ex_small_group: "Grupo reducido",
  ex_pickup: "Recogida",
  ex_accessible: "Accesible",
  ex_duration: "Duraci\u00f3n",
  ex_yes: "S\u00ed",
  ex_no: "No",
  ex_not_found_title: "Excursi\u00f3n no encontrada",
  ex_not_found_body: "La actividad que buscas no existe.",
  ex_back_home: "Volver al inicio",

  // Booking Widget
  bw_manage: "Gestionar tu reserva",
  bw_book: "Reservar",
  bw_option: "Elige una opci\u00f3n",
  bw_date: "Selecciona fecha",
  bw_adults: "Adultos",
  bw_children: "Ni\u00f1os",
  bw_infants: "Beb\u00e9s",
  bw_total: "Precio total",
  bw_add_cart: "A\u00f1adir al carrito",
  bw_book_now: "Reservar ahora",
  bw_added_msg: "\u00a1A\u00f1adido! Un experto local confirmar\u00e1 tu reserva en unas horas.",
  bw_instant: "Reserva segura — confianza de miles",
  bw_secure: "Pago seguro",

  // Language
  lang_pl: "Polski",
  lang_en: "English",
  lang_es: "Espa\u00f1ol",
  lang_modal_title: "Elige tu idioma",
  lang_modal_subtitle: "Selecciona tu idioma preferido para continuar",

  // Booking Form Modal
  bfm_title: "Completa tu reserva",
  bfm_success_title: "\u00a1Solicitud de reserva enviada!",
  bfm_success_body: "¡Gracias! Hemos recibido los datos de tu reserva y nos pondremos en contacto pronto.",
  bfm_excursion: "Excursi\u00f3n",
  bfm_date: "Fecha",
  bfm_guests: "Personas",
  bfm_name: "Nombre completo",
  bfm_name_placeholder: "Tu nombre completo",
  bfm_email: "Email",
  bfm_email_placeholder: "tu@email.com",
  bfm_phone: "Tel\u00e9fono / WhatsApp",
  bfm_message: "Solicitudes especiales",
  bfm_message_placeholder: "Nombre del hotel, lugar de recogida, necesidades diet\u00e9ticas...",
  bfm_submit: "Enviar solicitud de reserva",
  bfm_sending: "Enviando...",

  // Excursion titles
  "ex_title_buggy-volcano": "Expedici\u00f3n Buggy al Volc\u00e1n \u2014 3 Horas",
  "ex_title_jungle-park": "Jungle Park \u2014 Arona, Tenerife",
  "ex_title_twin-ticket": "Ticket Combinado \u2014 Loro Parque + Siam Park",

  // Excursion subtitles
  "ex_subtitle_buggy-volcano": "Aventura off-road Polaris RZR alrededor del Monte Teide",
  "ex_subtitle_jungle-park": "Conoce la fauna ex\u00f3tica, aves rapaces y majestuosos felinos",
  "ex_subtitle_twin-ticket": "Dos de los mejores parques tem\u00e1ticos del mundo en un solo ticket",

  // Category labels
  cat_adventure_nature: "Aventura y Naturaleza",
  cat_parks_tickets: "Parques y Entradas",

  // Reviews word
  ex_reviews_word: "opiniones",

  // Duration per excursion
  "ex_dur_buggy-volcano": "3 horas",
  "ex_dur_jungle-park": "4 \u2013 5 horas",
  "ex_dur_twin-ticket": "5 horas",

  // Variant labels
  "ex_var_buggy-volcano_0": "Buggy individual",
  "ex_var_buggy-volcano_1": "Buggy doble",
  "ex_var_jungle-park_0": "Entrada adulto",
  "ex_var_jungle-park_1": "Ni\u00f1o (5 \u2013 10 a\u00f1os)",
  "ex_var_jungle-park_2": "Beb\u00e9 (3 \u2013 4 a\u00f1os)",
  "ex_var_twin-ticket_0": "Twin Ticket Adulto",
  "ex_var_twin-ticket_1": "Twin Ticket Residente",
  "ex_var_twin-ticket_2": "Twin Ticket + Bus a Loro Parque",
  "ex_var_twin-ticket_3": "Traslado a Loro Parque",
  "ex_var_twin-ticket_4": "Bus Siam desde Puerto de la Cruz",

  // Schedule names (Jungle Park)
  "ex_sch_jungle-park_0": "Espect\u00e1culo de aves ex\u00f3ticas",
  "ex_sch_jungle-park_1": "Espect\u00e1culo de aves rapaces",
  "ex_sch_jungle-park_2": "Espect\u00e1culo de leones marinos",
  "ex_sch_jungle-park_3": "Alimentaci\u00f3n de ping\u00fcinos",

  // Park hours (Twin Ticket)
  "ex_hrs_twin-ticket_0_name": "Loro Parque",
  "ex_hrs_twin-ticket_0_info": "8:30 \u2013 18:45, 365 d\u00edas al a\u00f1o",
  "ex_hrs_twin-ticket_1_name": "Siam Park (Mayo \u2013 Oct)",
  "ex_hrs_twin-ticket_1_info": "10:00 \u2013 18:00",
  "ex_hrs_twin-ticket_2_name": "Siam Park (Nov \u2013 Abr)",
  "ex_hrs_twin-ticket_2_info": "10:00 \u2013 17:00",

  // BookingWidget
  bw_whatsapp_support: "Soporte WhatsApp:",
  bw_local_phone: "Local (Tenerife):",

  // Excursion Requirements
  "ex_req_buggy-volcano_0": "Carnet de conducir est\u00e1ndar obligatorio",
  "ex_req_buggy-volcano_1": "Los conductores menores de 23 a\u00f1os deben dejar un dep\u00f3sito de 250 \u20ac",
  "ex_req_twin-ticket_0": "Twin Ticket utiliza sistema de acceso con huella digital",

  // Excursion Included
  "ex_inc_buggy-volcano_0": "Recogida y traslado",
  "ex_inc_buggy-volcano_1": "Agua embotellada",
  "ex_inc_buggy-volcano_2": "Gafas antipolvo",
  "ex_inc_buggy-volcano_3": "Chaquetas y guantes calientes (si es necesario)",
  "ex_inc_buggy-volcano_4": "Seguro b\u00e1sico del veh\u00edculo",
  "ex_inc_buggy-volcano_5": "Experiencia de conducci\u00f3n inolvidable",
  "ex_inc_jungle-park_0": "Entrada completa",
  "ex_inc_jungle-park_1": "Autob\u00fas gratuito desde el sur de Tenerife",
  "ex_inc_twin-ticket_0": "Entrada a Loro Parque",
  "ex_inc_twin-ticket_1": "Entrada a Siam Park",
  "ex_inc_twin-ticket_2": "Voucher de confirmaci\u00f3n inmediata",

  // Excursion Highlights
  "ex_hl_buggy-volcano_0": "Recogida y traslado al hotel incluido, transferencia sin estr\u00e9s",
  "ex_hl_buggy-volcano_1": "Formaci\u00f3n profesional de seguridad antes de partir",
  "ex_hl_buggy-volcano_2": "15 minutos de pura adrenalina en un circuito volc\u00e1nico exclusivo",
  "ex_hl_buggy-volcano_3": "Degustaci\u00f3n opcional de vino &amp; tapas canarias despu\u00e9s del recorrido",
  "ex_hl_jungle-park_0": "Espect\u00e1culo de vuelo libre con \u00e1guilas, halcones y aves rapaces",
  "ex_hl_jungle-park_1": "Conoce al incre\u00edble tigre blanco, caimanes, monos &amp; leones",
  "ex_hl_jungle-park_2": "Entorno de jungla bellamente recreado",
  "ex_hl_jungle-park_3": "Servicio gratuito de autob\u00fas desde Los Cristianos, Las Am\u00e9ricas &amp; Costa Adeje",
  "ex_hl_twin-ticket_0": "Loro Parque \u2014 el mejor zoo del mundo con la mayor colecci\u00f3n de loros",
  "ex_hl_twin-ticket_1": "Siam Park \u2014 el parque acu\u00e1tico m\u00e1s grande de Europa con tem\u00e1tica tailandesa tropical",
  "ex_hl_twin-ticket_2": "Precio combinado especial, ahorra respecto a las entradas individuales",
  "ex_hl_twin-ticket_3": "15 d\u00edas de validez entre las dos visitas",

  // Excursion Taglines
  "ex_tagline_buggy-volcano": "Conduce los buggies Polaris RZR m\u00e1s potentes por senderos volc\u00e1nicos en Tenerife.",
  "ex_tagline_jungle-park": "Un zool\u00f3gico diferente centrado en la fauna de la jungla: aves rapaces, halcones, \u00e1guilas y animales ex\u00f3ticos de todo tipo.",
  "ex_tagline_twin-ticket": "Entrada combinada para visitar Loro Parque y Siam Park \u2014 votados como el mejor zoo y el mejor parque acu\u00e1tico del mundo por los usuarios de TripAdvisor.",

  // Excursion Recommendations
  "ex_rec_buggy-volcano_0": "Usa calzado y ropa c\u00f3modos",
  "ex_rec_buggy-volcano_1": "Trae una chaqueta, en las monta\u00f1as puede hacer fr\u00edo",
  "ex_rec_buggy-volcano_2": "Aplica protector solar \u2014 el sol de Tenerife es intenso, especialmente en verano",
  "ex_rec_jungle-park_0": "Llega temprano para ver el espect\u00e1culo de aves ex\u00f3ticas a las 11:00",
  "ex_rec_jungle-park_1": "Se recomienda calzado c\u00f3modo para caminar",
  "ex_rec_twin-ticket_0": "Reserva los traslados en autob\u00fas con al menos 24 horas de antelaci\u00f3n",
  "ex_rec_twin-ticket_1": "Tren gratuito desde Puerto de la Cruz a Loro Parque",

  // Nuevas categor\u00edas
  cat_boat_trips: "Paseos en Barco",
  cat_water_activities: "Actividades Acu\u00e1ticas",
  cat_entertainment: "Entretenimiento",

  // Two Parks Ticket
  "ex_title_two-parks-ticket": "Ticket Dos Parques \u2014 Jungle Park + Aqualand",
  "ex_subtitle_two-parks-ticket": "Visita dos incre\u00edbles parques tem\u00e1ticos en una sola entrada combinada",
  "ex_tagline_two-parks-ticket": "Dos parques, un ticket, cero complicaciones. Jungle Park te pone cara a cara con tigres blancos, \u00e1guilas y criaturas ex\u00f3ticas en medio de la selva, y luego Aqualand toma el relevo con toboganes, zonas de chapoteo y un r\u00edo lento para refrescarte. Usa el ticket en d\u00edas distintos, no hay prisa por hacerlo todo de golpe.",
  "ex_dur_two-parks-ticket": "6 horas",
  "ex_hl_two-parks-ticket_0": "Ac\u00e9rcate a felinos, aves rapaces y animales tropicales en los recintos naturales de Jungle Park",
  "ex_hl_two-parks-ticket_1": "Lo mejor de Aqualand: la piscina de olas gigante, toboganes serpenteantes y el largo r\u00edo lento",
  "ex_hl_two-parks-ticket_2": "Un solo ticket = dos parques. Te queda m\u00e1s dinero en el bolsillo que comprando por separado",
  "ex_hl_two-parks-ticket_3": "Reparte las visitas en d\u00edas distintos, cero presiones",
  "ex_inc_two-parks-ticket_0": "Entrada a Jungle Park",
  "ex_inc_two-parks-ticket_1": "Entrada a Aqualand Costa Adeje",
  "ex_inc_two-parks-ticket_2": "Voucher de confirmaci\u00f3n inmediata",
  "ex_rec_two-parks-ticket_0": "Lleva ba\u00f1ador, toalla y protector solar, vas a necesitar los tres en Aqualand",
  "ex_rec_two-parks-ticket_1": "Ve a Jungle Park por la ma\u00f1ana cuando los animales est\u00e1n m\u00e1s activos, y refr\u00e9scate en Aqualand despu\u00e9s de comer",
  "ex_var_two-parks-ticket_0": "Entrada adulto",
  "ex_var_two-parks-ticket_1": "Entrada ni\u00f1o",

  // Jeep Safari La Gomera
  "ex_title_jeep-safari-la-gomera": "Jeep Safari \u2014 Isla La Gomera",
  "ex_subtitle_jeep-safari-la-gomera": "Descubre la naturaleza salvaje y los paisajes de La Gomera en Jeep 4x4",
  "ex_tagline_jeep-safari-la-gomera": "Tomas el ferry por la ma\u00f1ana y pasas el d\u00eda recorriendo La Gomera en un Jeep 4x4 descapotable. Atraviesas valles de plataneras, caminas por bosques de laurisilva envueltos en niebla y te detienes en pueblos de monta\u00f1a que la mayor\u00eda de los turistas nunca llega a ver. Un almuerzo canario de verdad y el ferry de vuelta redondean el d\u00eda.",
  "ex_dur_jeep-safari-la-gomera": "9 horas",
  "ex_hl_jeep-safari-la-gomera_0": "Valle de Hermigua, bancales de plataneras y un pueblo tranquilo encajado entre dos monta\u00f1as",
  "ex_hl_jeep-safari-la-gomera_1": "Laguna Grande, un mirador amplio donde la isla se extiende a tus pies",
  "ex_hl_jeep-safari-la-gomera_2": "Parque Nacional de Garajonay, camina por bosques milenarios que exist\u00edan en tiempos de los dinosaurios",
  "ex_hl_jeep-safari-la-gomera_3": "Mirador de Agulo, el balc\u00f3n m\u00e1s bonito de la isla con el Teide al fondo sobre el oc\u00e9ano",
  "ex_hl_jeep-safari-la-gomera_4": "Almuerzo en un sitio familiar, sencillo, casero y absolutamente delicioso",
  "ex_inc_jeep-safari-la-gomera_0": "Ferry de ida y vuelta",
  "ex_inc_jeep-safari-la-gomera_1": "Jeep 4x4 (m\u00e1x. 8 personas por Jeep)",
  "ex_inc_jeep-safari-la-gomera_2": "Gu\u00eda local profesional",
  "ex_inc_jeep-safari-la-gomera_3": "Recogida y traslado al hotel",
  "ex_inc_jeep-safari-la-gomera_4": "Seguro de responsabilidad civil",
  "ex_rec_jeep-safari-la-gomera_0": "Calzado c\u00f3modo imprescindible, vas a estar subiendo y bajando del Jeep todo el día",
  "ex_rec_jeep-safari-la-gomera_1": "Recogida desde el sur: lun, mi\u00e9, vie. Desde el norte: solo lun y mi\u00e9",
  "ex_var_jeep-safari-la-gomera_0": "Adulto (Sur)",
  "ex_var_jeep-safari-la-gomera_1": "Niño 2-11 años (Sur)",
  "ex_var_jeep-safari-la-gomera_2": "Adulto (Norte)",
  "ex_var_jeep-safari-la-gomera_3": "Niño 2-11 años (Norte)",

  // Helicopter Flights
  "ex_title_helicopter-flights": "Vuelos Panor\u00e1micos en Helic\u00f3ptero \u2014 Tenerife",
  "ex_subtitle_helicopter-flights": "Descubre Tenerife desde arriba, 5 incre\u00edbles rutas a elegir",
  "ex_tagline_helicopter-flights": "Nada te prepara para c\u00f3mo se ve Tenerife desde el cielo. Un minuto flotas sobre playas doradas y al siguiente est\u00e1s mirando el cr\u00e1ter del Teide. Elige entre cinco rutas distintas, un paseo r\u00e1pido por la costa o un vuelo completo rodeando el volc\u00e1n. Las vistas a trav\u00e9s de esos ventanales son sencillamente incre\u00edbles.",
  "ex_dur_helicopter-flights": "8 \u2013 50 min",
  "ex_hl_helicopter-flights_0": "Cinco rutas totalmente diferentes, desde un bucle costero r\u00e1pido de 8 minutos hasta 50 minutos completos alrededor del Teide",
  "ex_hl_helicopter-flights_1": "Los vuelos m\u00e1s cortos te dan ese primer subid\u00f3n de helic\u00f3ptero con paisajes preciosos de playas y acantilados",
  "ex_hl_helicopter-flights_2": "Los vuelos largos te llevan al coraz\u00f3n de la isla, cr\u00e1teres volc\u00e1nicos, campos de lava y las monta\u00f1as de Teno",
  "ex_hl_helicopter-flights_3": "Ventanas de suelo a techo para que cada asiento tenga un encuadre perfecto para fotos y v\u00eddeo",
  "ex_inc_helicopter-flights_0": "Vuelo panor\u00e1mico en helic\u00f3ptero",
  "ex_inc_helicopter-flights_1": "Instrucciones de seguridad y equipo",
  "ex_req_helicopter-flights_0": "Se aplica l\u00edmite de peso por vuelo, consultar al reservar",
  "ex_rec_helicopter-flights_0": "En verano las plazas vuelan. Si tienes fechas fijas, res\u00e9rvalas cuanto antes",
  "ex_var_helicopter-flights_0": "Costa Sur \u2014 8-9 min",
  "ex_var_helicopter-flights_1": "Playas y Barrancos \u2014 12-15 min",
  "ex_var_helicopter-flights_2": "Playas, Barrancos y Acantilados \u2014 20-22 min",
  "ex_var_helicopter-flights_3": "Playas, Barrancos, Acantilados y Teno \u2014 35-40 min",
  "ex_var_helicopter-flights_4": "Teide y Alrededores \u2014 45-50 min",

  // Catamaran Dolphin Watching
  "ex_title_catamaran-dolphin-watching": "Catamar\u00e1n Avistamiento Delfines y Ballenas \u2014 4,5 horas",
  "ex_subtitle_catamaran-dolphin-watching": "Navega por la impresionante costa oeste y busca delfines y ballenas",
  "ex_tagline_catamaran-dolphin-watching": "Una tarde en condiciones sobre el agua. El catamar\u00e1n navega hacia el oeste rumbo a esos enormes acantilados de Los Gigantes mientras oteas el horizonte en busca de delfines y calderones, est\u00e1n aqu\u00ed todo el a\u00f1o, no solo de paso. A mitad del recorrido, la tripulaci\u00f3n echa el ancla para un ba\u00f1o con los acantilados dominando el paisaje. Recogidas martes y domingo desde el sur y el norte.",
  "ex_dur_catamaran-dolphin-watching": "4,5 horas",
  "ex_hl_catamaran-dolphin-watching_0": "Navega por la costa oeste, el catamar\u00e1n pone rumbo directo a los acantilados de Los Gigantes",
  "ex_hl_catamaran-dolphin-watching_1": "Los delfines y calderones son residentes aqu\u00ed, no visitantes, los avistamientos son muy frecuentes",
  "ex_hl_catamaran-dolphin-watching_2": "Parada para nadar a mitad del viaje justo bajo los acantilados, en un agua incre\u00edblemente transparente",
  "ex_hl_catamaran-dolphin-watching_3": "Recogida en hotel desde el sur y el norte cada martes y domingo",
  "ex_inc_catamaran-dolphin-watching_0": "Paseo en catamar\u00e1n",
  "ex_inc_catamaran-dolphin-watching_1": "Gu\u00eda bi\u00f3logo marino a bordo",
  "ex_rec_catamaran-dolphin-watching_0": "Ba\u00f1ador y toalla son obligatorios, te arrepentir\u00e1s si no te tiras al agua",
  "ex_rec_catamaran-dolphin-watching_1": "Estos paseos se llenan r\u00e1pido, sobre todo en temporada alta. Reserva con unos d\u00edas de antelaci\u00f3n si puedes",
  "ex_var_catamaran-dolphin-watching_0": "Adulto (Sur)",
  "ex_var_catamaran-dolphin-watching_1": "Ni\u00f1o 5-11 a\u00f1os (Sur)",

  // Pirate Ship Los Gigantes
  "ex_title_pirate-ship-los-gigantes": "Barco Pirata Avistamiento Delfines \u2014 Los Gigantes",
  "ex_subtitle_pirate-ship-los-gigantes": "Aventura de 3 horas desde el puerto de Los Gigantes en el legendario barco pirata Flipper Uno",
  "ex_tagline_pirate-ship-los-gigantes": "El Flipper Uno no es el t\u00edpico barco de excursi\u00f3n, es un aut\u00e9ntico barco pirata de madera que llama la atenci\u00f3n cada vez que sale del puerto de Los Gigantes. Tres horas a bordo: avistas delfines con la bi\u00f3loga marina, te tiras al oc\u00e9ano para un ba\u00f1o bajo esos acantilados gigantescos y luego te sientas a disfrutar de paella, pollo a la brasa y una bebida fr\u00eda. Dos salidas diarias, hasta 90 personas y el ambiente siempre es animado.",
  "ex_dur_pirate-ship-los-gigantes": "3 horas",
  "ex_hl_pirate-ship-los-gigantes_0": "El propio Flipper Uno, un aut\u00e9ntico barco pirata de madera que se ha convertido en un icono de Los Gigantes",
  "ex_hl_pirate-ship-los-gigantes_1": "Una bi\u00f3loga marina va a bordo en cada salida para ayudarte a avistar e identificar delfines y ballenas",
  "ex_hl_pirate-ship-los-gigantes_2": "Ba\u00f1o justo donde los acantilados se encuentran con el mar, el agua no puede ser m\u00e1s clara",
  "ex_hl_pirate-ship-los-gigantes_3": "Almuerzo reci\u00e9n preparado en cubierta: paella, pollo, vino, cerveza y refrescos incluidos",
  "ex_inc_pirate-ship-los-gigantes_0": "Vino tinto, cerveza, refrescos y agua a bordo",
  "ex_rec_pirate-ship-los-gigantes_0": "Dos salidas cada d\u00eda: 11:30 y 14:30. La de la tarde tiene una luz dorada preciosa",
  "ex_rec_pirate-ship-los-gigantes_1": "Trae c\u00e1mara, ba\u00f1ador y un poco de energ\u00eda, esto no es un crucero tranquilo de avistamiento",
  "ex_var_pirate-ship-los-gigantes_0": "Adulto",
  "ex_var_pirate-ship-los-gigantes_1": "Ni\u00f1o 2-11 a\u00f1os",
  "ex_var_pirate-ship-los-gigantes_2": "Beb\u00e9 0-2 a\u00f1os",

  // Night Skies Tenerife
  "ex_title_night-skies-tenerife": "Cielo Nocturno Tenerife \u2014 Observaci\u00f3n Estelar en Teide",
  "ex_subtitle_night-skies-tenerife": "Observa las estrellas con telescopios en el incre\u00edble cielo nocturno del Parque Nacional del Teide",
  "ex_tagline_night-skies-tenerife": "El Parque Nacional del Teide est\u00e1 por encima de las nubes, lejos de cualquier luz artificial, uno de los mejores lugares del planeta para mirar las estrellas. Un gu\u00eda te recorre el cielo nocturno con un l\u00e1ser tan potente que parece tocar la V\u00eda L\u00e1ctea, mientras los telescopios te acercan los anillos de Saturno y galaxias lejanas. Tambi\u00e9n hay opci\u00f3n con puesta de sol si quieres la transici\u00f3n completa.",
  "ex_dur_night-skies-tenerife": "3 \u2013 4 horas",
  "ex_hl_night-skies-tenerife_0": "El Teide de noche, cero contaminaci\u00f3n lum\u00ednica, solo t\u00fa y un cielo repleto de estrellas",
  "ex_hl_night-skies-tenerife_1": "L\u00e1seres verdes potentes, el gu\u00eda literalmente dibuja las constelaciones sobre la V\u00eda L\u00e1ctea",
  "ex_hl_night-skies-tenerife_2": "Telescopios profesionales preparados para que veas Saturno, J\u00fapiter y objetos del espacio profundo de cerca",
  "ex_hl_night-skies-tenerife_3": "Recogida en tu hotel del sur, no tienes que conducir por carreteras de monta\u00f1a de noche",
  "ex_inc_night-skies-tenerife_0": "Recogida y traslado al hotel desde el sur de Tenerife",
  "ex_inc_night-skies-tenerife_1": "Gu\u00eda experto en astronom\u00eda",
  "ex_req_night-skies-tenerife_0": "Trae ropa abrigada, las temperaturas en altura bajan mucho por la noche",
  "ex_req_night-skies-tenerife_1": "Se recomienda calzado c\u00f3modo para terreno volc\u00e1nico irregular",
  "ex_rec_night-skies-tenerife_0": "Tours en ingl\u00e9s, espa\u00f1ol, alem\u00e1n, holand\u00e9s y chino disponibles bajo petici\u00f3n",
  "ex_var_night-skies-tenerife_0": "Puesta de Sol y Estrellas \u2014 Transporte Propio",
  "ex_var_night-skies-tenerife_1": "Safari Estelar (Sin Cena)",
  "ex_var_night-skies-tenerife_2": "Safari Estelar (Cena Incluida)",

  // Ol\u00e9 Flamenco Show
  "ex_title_ole-flamenco-show": "Espect\u00e1culo de Flamenco Ol\u00e9 \u2014 Costa Adeje",
  "ex_subtitle_ole-flamenco-show": "Una noche de danza espa\u00f1ola, pasi\u00f3n y color en el Hotel GF Victoria",
  "ex_tagline_ole-flamenco-show": "Los jueves por la noche en el Hotel GF Victoria son territorio flamenco. El espect\u00e1culo lo dirige Fran Chafino, un bailar\u00edn que ha actuado por toda Espa\u00f1a, y su compa\u00f1\u00eda lo da todo: zapateado, cante, guitarra en directo y pura emoci\u00f3n. Puedes elegir la entrada Oro solo para el espect\u00e1culo o la Platino con cena antes de que se abra el tel\u00f3n. En cualquier caso, llega antes de las 20:30.",
  "ex_dur_ole-flamenco-show": "2 horas",
  "ex_hl_ole-flamenco-show_0": "La compa\u00f1\u00eda de Fran Chafino, son artistas de verdad, no un espect\u00e1culo tur\u00edstico cualquiera",
  "ex_hl_ole-flamenco-show_1": "Todo el espectro del flamenco: piezas de guitarra solista, n\u00fameros de baile en grupo y momentos de cante que ponen la piel de gallina",
  "ex_hl_ole-flamenco-show_2": "Todos los jueves en el Hotel GF Victoria de Costa Adeje, recepci\u00f3n a las 20:30",
  "ex_hl_ole-flamenco-show_3": "Oro para el espect\u00e1culo, Platino si quieres cenar antes de que empiece la funci\u00f3n",
  "ex_inc_ole-flamenco-show_0": "Entrada al espect\u00e1culo de flamenco",
  "ex_req_ole-flamenco-show_0": "No se permiten fotos ni v\u00eddeos durante el espect\u00e1culo",
  "ex_rec_ole-flamenco-show_0": "La funci\u00f3n empieza a las 21:00 en punto. Llega a las 20:30 para tomar algo y acomodarte",
  "ex_rec_ole-flamenco-show_1": "Viste smart casual, est\u00e1s en un hotel elegante, no en la playa",
  "ex_var_ole-flamenco-show_0": "Oro \u2014 Adulto",
  "ex_var_ole-flamenco-show_1": "Oro \u2014 Ni\u00f1o (3-11 a\u00f1os)",
  "ex_var_ole-flamenco-show_2": "Platino \u2014 Adulto",
  "ex_var_ole-flamenco-show_3": "Platino \u2014 Ni\u00f1o (3-11 a\u00f1os)",

  // Jet Ski Los Gigantes
  "ex_title_jet-ski-los-gigantes": "Jet Ski Los Gigantes \u2014 Safari Azul",
  "ex_subtitle_jet-ski-los-gigantes": "Tour guiado en moto de agua de Los Gigantes a Punta de Teno con dos paradas exclusivas",
  "ex_tagline_jet-ski-los-gigantes": "Una hora en moto de agua por el tramo m\u00e1s salvaje de la costa de Tenerife. Sales del puerto de Los Gigantes con un gu\u00eda abriendo camino, surcas el Atl\u00e1ntico hacia el barranco de Masca y luego sigues hasta Punta de Teno, un cabo remoto donde la isla se acaba y solo queda oc\u00e9ano por delante. Dos paradas para recuperar el aliento, hacer fotos y empaparte del paisaje antes de volver.",
  "ex_dur_jet-ski-los-gigantes": "1 hora",
  "ex_hl_jet-ski-los-gigantes_0": "Sal del puerto de Los Gigantes y pon rumbo directo al Barranco de Masca",
  "ex_hl_jet-ski-los-gigantes_1": "Dos paradas por el camino, el barranco de Masca y el impresionante faro de Punta de Teno",
  "ex_hl_jet-ski-los-gigantes_2": "Ve solo o lleva a alguien detr\u00e1s, motos individuales y dobles disponibles",
  "ex_hl_jet-ski-los-gigantes_3": "Trajes de neopreno, chalecos salvavidas y una sesi\u00f3n completa de seguridad antes de tocar el agua",
  "ex_inc_jet-ski-los-gigantes_0": "Chaleco salvavidas",
  "ex_inc_jet-ski-los-gigantes_1": "Traje de neopreno",
  "ex_inc_jet-ski-los-gigantes_2": "Vestuarios",
  "ex_inc_jet-ski-los-gigantes_3": "Taquilla",
  "ex_inc_jet-ski-los-gigantes_4": "Toalla",
  "ex_inc_jet-ski-los-gigantes_5": "Duchas",
  "ex_inc_jet-ski-los-gigantes_6": "Briefing de seguridad",
  "ex_inc_jet-ski-los-gigantes_7": "Seguro de responsabilidad civil y accidentes",
  "ex_req_jet-ski-los-gigantes_0": "Altura m\u00ednima para conducir: 1,35 m",
  "ex_req_jet-ski-los-gigantes_1": "Peso m\u00e1ximo por moto de agua: 200 kg",
  "ex_req_jet-ski-los-gigantes_2": "Se requiere conocimiento b\u00e1sico de nataci\u00f3n",
  "ex_req_jet-ski-los-gigantes_3": "No recomendado para embarazadas ni personas con problemas card\u00edacos, de espalda o articulaciones",
  "ex_var_jet-ski-los-gigantes_0": "Moto de agua individual",
  "ex_var_jet-ski-los-gigantes_1": "Moto de agua doble",

  // VIP Private Tour Tenerife
  "ex_title_vip-tour-tenerife": "Tour VIP Privado \u2014 Tenerife",
  "ex_subtitle_vip-tour-tenerife": "Descubre el Tenerife real a tu ritmo con un gu\u00eda privado",
  "ex_tagline_vip-tour-tenerife": "Olv\u00eddate de los horarios r\u00edgidos de autob\u00fas y los miradores abarrotados. Esto es tu propio coche privado con un conductor-gu\u00eda que conoce cada carretera secundaria, cada mirador escondido y cada restaurante familiar de la isla. T\u00fa mandas: paras para fotos cuando quieras, te saltas lo que no te interesa y te quedas m\u00e1s tiempo donde te apetezca. Ocho horas de Tenerife a tu manera.",
  "ex_dur_vip-tour-tenerife": "8 horas",
  "ex_hl_vip-tour-tenerife_0": "Solo t\u00fa y tu grupo, sin desconocidos, sin esperar a nadie m\u00e1s",
  "ex_hl_vip-tour-tenerife_1": "Tu gu\u00eda te lleva a sitios donde los autobuses grandes no llegan, miradores tranquilos y secretos locales",
  "ex_hl_vip-tour-tenerife_2": "La ruta se adapta a lo que te gusta, no al rev\u00e9s. Cambia de plan a media ma\u00f1ana si te apetece",
  "ex_hl_vip-tour-tenerife_3": "Coche privado c\u00f3modo, servicio puerta a puerta y un gu\u00eda que de verdad escucha lo que quieres",
  "ex_hl_vip-tour-tenerife_4": "Recogida desde cualquier punto de la isla, tu hotel, apartamento, incluso el aeropuerto",
  "ex_inc_vip-tour-tenerife_0": "Veh\u00edculo privado con conductor-gu\u00eda",
  "ex_inc_vip-tour-tenerife_1": "Recogida desde cualquier lugar de la isla",
  "ex_rec_vip-tour-tenerife_0": "Los tours se realizan de lunes a viernes",
  "ex_rec_vip-tour-tenerife_1": "Suplemento de 30\u20ac para recogida desde Puerto de La Cruz, Santa Cruz o Candelaria",
  "ex_var_vip-tour-tenerife_0": "2 personas",
  "ex_var_vip-tour-tenerife_1": "3 personas",
  "ex_var_vip-tour-tenerife_2": "4 personas",
  "ex_var_vip-tour-tenerife_3": "5+ personas",

  // Kayak Los Gigantes
  "ex_title_kayak-los-gigantes": "Kayak Los Gigantes \u2014 Acantilados y Oc\u00e9ano",
  "ex_subtitle_kayak-los-gigantes": "Explora los majestuosos acantilados de Los Gigantes en kayak, una experiencia oce\u00e1nica pura",
  "ex_tagline_kayak-los-gigantes": "Navegar en kayak bajo esos acantilados de 600 metros es una pasada, desde el nivel del agua no parecen reales. Una lancha te lleva r\u00e1pidamente del puerto al punto de partida, y luego pasas dos horas desliz\u00e1ndote por la base de Los Gigantes, asom\u00e1ndote a calas escondidas y flotando sobre un agua tan clara que ves el fondo. Grupos reducidos y la luz de la tarde hace que las paredes de roca brillen.",
  "ex_dur_kayak-los-gigantes": "2 horas",
  "ex_hl_kayak-los-gigantes_0": "Rema justo debajo de los acantilados, pr\u00e1cticamente puedes tocar la pared volc\u00e1nica",
  "ex_hl_kayak-los-gigantes_1": "Los acantilados caen 600 metros directos al oc\u00e9ano. Desde un kayak impresionan todav\u00eda m\u00e1s",
  "ex_hl_kayak-los-gigantes_2": "Grupos peque\u00f1os para que nunca vayas apretado ni con prisas",
  "ex_hl_kayak-los-gigantes_3": "Traslado en barco del puerto a la zona de remo y vuelta, sin aproximaciones cansadas",
  "ex_inc_kayak-los-gigantes_0": "Bebidas",
  "ex_inc_kayak-los-gigantes_1": "Ducha",
  "ex_inc_kayak-los-gigantes_2": "Equipo de kayak",
  "ex_inc_kayak-los-gigantes_3": "Traslado en barco a la zona de kayak y vuelta",
  "ex_req_kayak-los-gigantes_0": "Se requiere capacidad de nataci\u00f3n",
  "ex_req_kayak-los-gigantes_1": "No recomendado para personas con problemas de espalda o articulaciones",
  "ex_var_kayak-los-gigantes_0": "Adulto \u2014 sesi\u00f3n 13:00",
  "ex_var_kayak-los-gigantes_1": "Ni\u00f1o (6-9 a\u00f1os) \u2014 sesi\u00f3n 13:00",

  // Parapente Tenerife
  "ex_title_paragliding-tenerife": "Parapente Tenerife \u2014 Vuelos T\u00e1ndem",
  "ex_subtitle_paragliding-tenerife": "Vuelos t\u00e1ndem sobre la costa atl\u00e1ntica \u2014 Bronze, Silver y Acrob\u00e1tico",
  "ex_tagline_paragliding-tenerife": "Hay muy pocas cosas en el mundo comparables a despegar de una monta\u00f1a y planear sobre el Atl\u00e1ntico con Tenerife extendida bajo tus pies. El vuelo Bronze es la puerta de entrada perfecta: 10-20 minutos desde 800 m con vistas que quitan el aliento. El Silver alarga el placer hasta 20-40 minutos y permite salir desde Ifonche a 1000 m (salida desde Ifonche = autom\u00e1ticamente Silver). El Acrob\u00e1tico es adrenalina pura: m\u00e1xima altitud, espirales, wingovers y maniobras din\u00e1micas sobre el oc\u00e9ano. Para cualquier vuelo puedes a\u00f1adir el pack de fotos y v\u00eddeos por +30 \u20ac.",
  "ex_dur_paragliding-tenerife": "10 \u2013 40 min",
  "ex_hl_paragliding-tenerife_0": "Bronze 110\u20ac \u2014 salida desde 800 m, 10-20 minutos, perfecto para el primer vuelo",
  "ex_hl_paragliding-tenerife_1": "Silver 130\u20ac \u2014 salida desde 800 m o Ifonche (1000 m), 20-40 minutos. Ifonche = autom\u00e1ticamente Silver",
  "ex_hl_paragliding-tenerife_2": "Acrob\u00e1tico 140\u20ac \u2014 m\u00e1xima altitud, espirales y wingovers sobre el oc\u00e9ano para los buscadores de emociones",
  "ex_hl_paragliding-tenerife_3": "Pack fotos y v\u00eddeo +30\u20ac \u2014 disponible para cualquier vuelo, para que el recuerdo dure",
  "ex_hl_paragliding-tenerife_4": "Vuela en t\u00e1ndem con un instructor certificado \u2014 no se necesita experiencia previa",
  "ex_inc_paragliding-tenerife_0": "Vuelo t\u00e1ndem con instructor certificado",
  "ex_inc_paragliding-tenerife_1": "Arneses de parapente y equipo de seguridad",
  "ex_inc_paragliding-tenerife_2": "Briefing de seguridad previo al vuelo",
  "ex_req_paragliding-tenerife_0": "L\u00edmite de peso: 30-110 kg por pasajero \u2014 inf\u00f3rmanos al reservar",
  "ex_req_paragliding-tenerife_1": "No recomendado para personas con problemas card\u00edascos o v\u00e9rtigo severo",
  "ex_rec_paragliding-tenerife_0": "Lleva calzado cerrado c\u00f3modo y capas ligeras \u2014 puede hacer viento en altura",
  "ex_rec_paragliding-tenerife_1": "Los vuelos dependen del tiempo \u2014 confirmamos el d\u00eda anterior y ofrecemos reagendamiento completo si el viento no acompa\u00f1a",
  "ex_var_paragliding-tenerife_0": "Bronze \u2014 10-20 min",
  "ex_var_paragliding-tenerife_1": "Silver \u2014 20-40 min",
  "ex_var_paragliding-tenerife_2": "Acrob\u00e1tico \u2014 m\u00e1x. altitud",
  "ex_var_paragliding-tenerife_3": "+ Pack Fotos y V\u00eddeo (cualquier vuelo)",

  // ─── Crucero en Yate Puerto Colón ───────────────────────────────────────
  "ex_title_yacht-cruise-puerto-colon": "Crucero en Yate \u2014 3 Horas desde Puerto Col\u00f3n",
  "ex_subtitle_yacht-cruise-puerto-colon": "Exclusivo paseo en yate de 3 horas con bebidas, avistamiento de delfines y parada para nadar",
  "ex_tagline_yacht-cruise-puerto-colon": "Tres horas a bordo de un yate privado desde Puerto Col\u00f3n \u2014 con un m\u00e1ximo de solo 11 personas en cubierta, as\u00ed que si vienes con todo tu grupo pr\u00e1cticamente tienes el barco para vosotros solos. El plan: navegar en busca de delfines, ballenas y orcas, echar el ancla en una playa preciosa para un ba\u00f1o en el oc\u00e9ano, y s\u00ed \u2014 las bebidas, el vino y la cerveza van por cuenta de la casa. Sol, mar y buen rollo garantizados.",
  "ex_dur_yacht-cruise-puerto-colon": "3 horas",
  "ex_hl_yacht-cruise-puerto-colon_0": "Navegaci\u00f3n en busca de delfines, ballenas y orcas \u2014 estas aguas est\u00e1n llenas de vida marina",
  "ex_hl_yacht-cruise-puerto-colon_1": "Parada para nadar en una playa escondida de aguas cristalinas",
  "ex_hl_yacht-cruise-puerto-colon_2": "M\u00e1ximo 11 personas a bordo \u2014 ambiente \u00edntimo, sin aglomeraciones",
  "ex_hl_yacht-cruise-puerto-colon_3": "Bebidas, vino y cerveza incluidos \u2014 navega con estilo",
  "ex_inc_yacht-cruise-puerto-colon_0": "Paseo en yate de 3 horas",
  "ex_inc_yacht-cruise-puerto-colon_1": "Bebidas, vino y cerveza a bordo",
  "ex_inc_yacht-cruise-puerto-colon_2": "Parada para nadar en la playa",
  "ex_rec_yacht-cruise-puerto-colon_0": "Trae ba\u00f1ador, toalla y protector solar \u2014 vas a querer tirarte al agua",
  "ex_rec_yacht-cruise-puerto-colon_1": "Si sois un grupo grande (8\u201311 personas), reservad con antelaci\u00f3n \u2014 las plazas vuelan",
  "ex_var_yacht-cruise-puerto-colon_0": "Adulto",

  // ─── Aqualand Costa Adeje
  "ex_title_aqualand-costa-adeje": "Aqualand Costa Adeje — Parque Acuático",
  "ex_subtitle_aqualand-costa-adeje": "El mayor parque acuático del sur de Tenerife con delfinario propio",
  "ex_tagline_aqualand-costa-adeje": "Aqualand no es solo un parque acuático. Tiene un delfinario propio con 10 delfines, cinco de ellos nacidos y criados aquí. Kamikaze, Super Slalom, Twister, Anaconda, Crazy Race y el nuevo Boomerang para los amantes de la adrenalina. Bus gratuito desde Los Cristianos, Las Américas y Costa Adeje. Horario sep–jun 10:00–17:30, jul–ago 10:00–18:00.",
  "ex_dur_aqualand-costa-adeje": "4 – 5 horas",
  "ex_hl_aqualand-costa-adeje_0": "Delfinario propio con espectáculo — los delfines son las estrellas del parque",
  "ex_hl_aqualand-costa-adeje_1": "Kamikaze, Super Slalom, Twister, Anaconda — toboganes clásicos más el nuevo Boomerang",
  "ex_hl_aqualand-costa-adeje_2": "Mini Park para los más pequeños — zona de agua segura para niños",
  "ex_hl_aqualand-costa-adeje_3": "Bus gratuito desde Los Cristianos, Las Américas y Costa Adeje",
  "ex_inc_aqualand-costa-adeje_0": "Entrada al parque",
  "ex_inc_aqualand-costa-adeje_1": "Autobús gratuito desde el sur de Tenerife",
  "ex_rec_aqualand-costa-adeje_0": "Comprueba los horarios del espectáculo de delfines — sep–jun 15:30, jul–ago 12:45 y 15:30",
  "ex_rec_aqualand-costa-adeje_1": "El parque cierra a las 17:30 en invierno y a las 18:00 en verano — planifica bien",
  "ex_var_aqualand-costa-adeje_0": "Entrada adulto",
  "ex_var_aqualand-costa-adeje_1": "Niño (5–10 años)",
  "ex_var_aqualand-costa-adeje_2": "Infante (3–4 años)",

  // ─── Siam Park
  "ex_title_siam-park-tenerife": "Siam Park — Mejor Parque Acuático del Mundo",
  "ex_subtitle_siam-park-tenerife": "7 veces elegido mejor parque acuático del mundo por TripAdvisor",
  "ex_tagline_siam-park-tenerife": "Siam Park ha sido nombrado el mejor parque acuático del mundo siete años consecutivos. Tower of Power es un tobogán de 28 metros que termina bajo el agua con tiburones y rayas. Singha es la montaña rusa acuática más rápida del mundo con 14 cambios de dirección. Siam Beach tiene 13.000 m² de arena blanca y piscina de olas. Hamacas y sombrillas incluidas en la entrada. Verano 10–18, invierno 10–17.",
  "ex_dur_siam-park-tenerife": "5 horas",
  "ex_hl_siam-park-tenerife_0": "Tower of Power — 28 metros de caída libre a través de un acuario con tiburones y rayas",
  "ex_hl_siam-park-tenerife_1": "Singha — la montaña rusa acuática más rápida del mundo con 250 metros de recorrido",
  "ex_hl_siam-park-tenerife_2": "Siam Beach — 13.000 m² de arena blanca, piscina de olas y hamacas incluidas en la entrada",
  "ex_hl_siam-park-tenerife_3": "Coco Beach — zona acuática exclusiva para los más pequeños con atracciones adaptadas",
  "ex_inc_siam-park-tenerife_0": "Entrada al parque",
  "ex_inc_siam-park-tenerife_1": "Hamacas y sombrillas todo el día",
  "ex_rec_siam-park-tenerife_0": "Llega a la apertura — las colas de Tower of Power son más cortas a primera hora",
  "ex_rec_siam-park-tenerife_1": "Reserva con antelación el bus desde Puerto de la Cruz, se llena rápido",
  "ex_hrs_siam-park-tenerife_0_name": "Verano (Mayo – Oct)",
  "ex_hrs_siam-park-tenerife_0_info": "10:00 – 18:00",
  "ex_hrs_siam-park-tenerife_1_name": "Invierno (Nov – Abr)",
  "ex_hrs_siam-park-tenerife_1_info": "10:00 – 17:00",
  "ex_var_siam-park-tenerife_0": "Entrada adulto",
  "ex_var_siam-park-tenerife_1": "Entrada residente",
  "ex_var_siam-park-tenerife_2": "Transfer desde Puerto de la Cruz",

  // ─── Loro Parque
  "ex_title_loro-parque-tenerife": "Loro Parque — Mejor Zoológico del Mundo",
  "ex_subtitle_loro-parque-tenerife": "Santuario de 400+ especies con espectáculos de orcas, delfines y loros",
  "ex_tagline_loro-parque-tenerife": "Loro Parque no es un zoo cualquiera. Cada animal tiene un plan de cuidado personalizado desarrollado por veterinarios expertos. Orcas, delfines, leones marinos, loros, tigres, pingüinos — más de 400 especies en los preciosos jardines de Puerto de la Cruz. Espectáculos varias veces al día. Y sí, realmente ha sido votado el mejor zoo del mundo por TripAdvisor.",
  "ex_dur_loro-parque-tenerife": "5 horas",
  "ex_hl_loro-parque-tenerife_0": "Espectáculo de orcas — dos veces al día a las 11:55 y 15:15, impresionante",
  "ex_hl_loro-parque-tenerife_1": "Espectáculos de delfines, leones marinos y loros — 20 minutos cada uno, horario incluido",
  "ex_hl_loro-parque-tenerife_2": "Tigres blancos, caimanes, gorilas, pingüinos y más de 400 especies",
  "ex_hl_loro-parque-tenerife_3": "Bus gratuito desde el sur de Tenerife o transfer directo desde tu hotel",
  "ex_inc_loro-parque-tenerife_0": "Entrada completa",
  "ex_rec_loro-parque-tenerife_0": "Llega pronto — las puertas abren a las 9:30. Primer espectáculo de orcas a las 11:55",
  "ex_rec_loro-parque-tenerife_1": "Tren gratuito desde el puerto de Puerto de la Cruz — baja en la parada Loro Parque",
  "ex_var_loro-parque-tenerife_0": "Entrada adulto",
  "ex_var_loro-parque-tenerife_1": "Entrada residente",
  "ex_var_loro-parque-tenerife_2": "Entrada + bus",
  "ex_var_loro-parque-tenerife_3": "Transfer",
  "ex_sch_loro-parque-tenerife_0": "Espectáculo Leones Marinos",
  "ex_sch_loro-parque-tenerife_1": "Loro Show (loros)",
  "ex_sch_loro-parque-tenerife_2": "Espectáculo Delfines",
  "ex_sch_loro-parque-tenerife_3": "Espectáculo Orcas",

  // ─── Castillo San Miguel
  "ex_title_castillo-san-miguel": "Castillo San Miguel — Noche Medieval",
  "ex_subtitle_castillo-san-miguel": "Torneo ecuestre con banquete medieval en el castillo del Conde Don Rodrigo",
  "ex_tagline_castillo-san-miguel": "Entras al castillo del Conde Don Rodrigo, escuchas los cascos en la arena y tienes delante una pista de 50 metros. Caballeros con armadura completa compiten, el público anima a su campeón — y tú comes un pollo entero con las manos mientras bebes vino del jarro. Exactamente la noche medieval que imaginabas. Espectáculos martes, jueves y sábados.",
  "ex_dur_castillo-san-miguel": "3 horas",
  "ex_hl_castillo-san-miguel_0": "Torneo ecuestre auténtico en una pista de arena de 50 metros — animas a uno de 6 caballeros",
  "ex_hl_castillo-san-miguel_1": "Banquete medieval: sopa del bol, pollo comido con las manos, vino y zumo sin límite",
  "ex_hl_castillo-san-miguel_2": "Tras el torneo — el Salón de Baile con música y ambiente festivo",
  "ex_hl_castillo-san-miguel_3": "Transfer desde tu hotel en el sur de Tenerife disponible como opción",
  "ex_inc_castillo-san-miguel_0": "Entrada al espectáculo",
  "ex_inc_castillo-san-miguel_1": "Cena medieval con vino y zumos",
  "ex_req_castillo-san-miguel_0": "Solo martes, jueves y sábados. Recepción desde las 18:30, espectáculo a las 19:30",
  "ex_rec_castillo-san-miguel_0": "Reserva el transfer — la ubicación está fuera del centro turístico, difícil llegar en taxi a tiempo",
  "ex_rec_castillo-san-miguel_1": "Menú vegetariano disponible — avísanos al reservar",
  "ex_var_castillo-san-miguel_0": "Show + Cena",
  "ex_var_castillo-san-miguel_1": "Show + Cena VIP",
  "ex_var_castillo-san-miguel_2": "Show + Cena + Transporte",

  // ─── Sea Fishing Trip
  "ex_title_sea-fishing-tenerife": "Excursión de Pesca en el Mar — Tenerife",
  "ex_subtitle_sea-fishing-tenerife": "Todo el barco solo para vosotros — pesca de altura en el sur de Tenerife",
  "ex_tagline_sea-fishing-tenerife": "Subid a bordo y pasad horas inolvidables en el mar. Todo el barco es solo para vosotros, máximo 4 personas, 120 € por hora. Ideal para familias, amigos o un pequeño grupo de pescadores. No se necesita experiencia — lo importante es divertirse, el mar y la emoción a bordo.",
  "ex_dur_sea-fishing-tenerife": "3 – 4 horas",
  "ex_hl_sea-fishing-tenerife_0": "Todo el barco exclusivo para tu grupo — salida privada, máximo 4 personas a bordo",
  "ex_hl_sea-fishing-tenerife_1": "120 € / hora — duración flexible: 3 horas (360 €) o 4 horas (480 €)",
  "ex_hl_sea-fishing-tenerife_2": "Pesca de altura en el sur de Tenerife con patrón experimentado y equipo completo",
  "ex_hl_sea-fishing-tenerife_3": "No se necesita experiencia — el patrón te guía, tú solo disfruta y saca peces",
  "ex_inc_sea-fishing-tenerife_0": "Barco privado con patrón experimentado",
  "ex_inc_sea-fishing-tenerife_1": "Equipo de pesca completo y cebo",
  "ex_inc_sea-fishing-tenerife_2": "Bebidas a bordo",
  "ex_inc_sea-fishing-tenerife_3": "Ayuda para preparar la pesca capturada",
  "ex_rec_sea-fishing-tenerife_0": "Trae protector solar, gorra y gafas de sol — el sol es intenso en el mar",
  "ex_rec_sea-fishing-tenerife_1": "Calzado cómodo con suela antideslizante — la cubierta puede estar mojada",
  "ex_req_sea-fishing-tenerife_0": "Se requiere capacidad básica de natación",
  "ex_var_sea-fishing-tenerife_0": "3 horas",
  "ex_var_sea-fishing-tenerife_1": "4 horas",

  // ─── Anaga Mountain Hike
  "ex_title_anaga-mountain-hike": "Caminata por las mágicas montañas de Anaga",
  "ex_subtitle_anaga-mountain-hike": "Una caminata corta e intensa por el misterioso bosque de laurisilva y vistas espectaculares",
  "ex_tagline_anaga-mountain-hike": "Salimos en grupo reducido y descubrimos uno de los lugares más extraordinarios de Tenerife. Te esperan el misterioso bosque de laurisilva, la niebla flotando entre los helechos y unas vistas espectaculares de valles y barrancos. Es una dosis corta e intensa de naturaleza que se queda en la memoria durante mucho tiempo.",
  "ex_dur_anaga-mountain-hike": "2,5 – 3 horas",
  "ex_hl_anaga-mountain-hike_0": "Misterioso bosque de laurisilva — naturaleza ancestral declarada Patrimonio de la UNESCO",
  "ex_hl_anaga-mountain-hike_1": "Niebla, helechos y un ambiente único, casi de cuento, en los barrancos de Anaga",
  "ex_hl_anaga-mountain-hike_2": "Vistas espectaculares de valles y barrancos desde los miradores de montaña",
  "ex_hl_anaga-mountain-hike_3": "Grupo reducido — máximo 10 personas para mantener un ambiente íntimo",
  "ex_inc_anaga-mountain-hike_0": "Guía de montaña local experimentado",
  "ex_inc_anaga-mountain-hike_1": "Caminata en grupo reducido (máx. 10 personas)",
  "ex_inc_anaga-mountain-hike_2": "Seguro durante la caminata",
  "ex_req_anaga-mountain-hike_0": "Condición física básica — nivel fácil a medio",
  "ex_req_anaga-mountain-hike_1": "Lleva tu propia agua y tentempiés",
  "ex_rec_anaga-mountain-hike_0": "Calzado de senderismo cómodo imprescindible — la ruta sigue senderos forestales",
  "ex_rec_anaga-mountain-hike_1": "Lleva una chaqueta ligera y capas — en el bosque de laurisilva hay niebla y humedad",
  "ex_rec_anaga-mountain-hike_2": "El transporte al punto de partida se organiza individualmente — pregunta al reservar",
  "ex_var_anaga-mountain-hike_0": "Persona (mín. 3 personas)",
};